import banner from "../../assets/header-bg.jpg";
import logo from "../../assets/logo.png";
import { ClockCircleOutlined, PhoneOutlined } from "@ant-design/icons";
import { Button, Drawer, Empty, Tag } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
const Index = (props) => {
  const [open, setOpen] = useState(false);
  const handleMainWeb = () => {
    window?.open("https://ezstart.mn", "_blank");
  };

  useEffect(() => {
    if (open && props?.collect?.phonen) {
      props?.request({
        url: `/order/user/list/${props?.collect?.phonen}`,
        model: "orderlist",
        method: "POST",
      });
    }
  }, [open]);

  const renderData = () => {
    let tmp = props?.resorderlist?.map((item, i) => (
      <div className="bg-infobg p-2 rounded-md shadow shadow-sm text-sm gap-1 flex flex-col">
        <div className="flex items-center justify-between">
          <span>Утасны дугаар</span>
          <span className="font-bold">{item?.phone}</span>
        </div>
        <div className="flex items-center justify-between">
          <span>Машины дугаар</span>
          <span className="font-bold">{item?.carnumber}</span>
        </div>
        <div className="flex items-center justify-between">
          <span>Захиалгын огноо</span>
          <span className="font-bold">
            {dayjs(item?.orderdate)?.format("YYYY-MM-DD HH:mm")}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span>Урьдчилгаа</span>
          <span className="font-bold">
            {new Intl.NumberFormat().format(item?.amount || 0)}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span>Төлсөн эсэх</span>
          <span className="font-bold">
            {item?.ispayd ? (
              <Tag color="#87d068" className="w-full text-center">
                Төлсөн
              </Tag>
            ) : (
              <Tag color="#f50" className="w-full text-center">
                Төлөөгүй
              </Tag>
            )}
          </span>
        </div>
      </div>
    ));

    return tmp;
  };

  return (
    <div
      className="w-full h-48 lg:h-96 flex flex-col items-center"
      style={{
        backgroundImage: `url(${banner})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex flex-col container bg-primary rounded-b-lg">
        <div className="bg-second py-2 px-4 text-white flex justify-between w-full">
          <div className="flex items-center justify-between w-full">
            <div className="flex text-xs flex ">
              <ClockCircleOutlined className="mr-2 text-third" />
              <span>СБД, 100 айл, Авто плаза 1 төв, 2 давхар, 21А</span>
            </div>
            <div className="flex text-xs flex">
              <PhoneOutlined className="mr-2 text-third" />
              <span>7712-6688</span>
            </div>
          </div>
        </div>
        <div className="flex items-center">
          <div className="bg-white logo-container pl-4 pr-10 py-4 lg:py-10 rounded-b-lg w-fit h-full flex items-center">
            <img src={logo} alt={logo} className="h-10 object-contain" />
          </div>
          <div className="w-full px-4 flex justify-center lg:justify-end lg:px-10">
            <div className="flex gap-2 flex-col lg:flex-row py-2">
              {props?.collect?.phonen ? (
                <Button className="text-xs" onClick={() => setOpen(true)}>
                  Захиалгын түүх харах
                </Button>
              ) : null}

              <Button
                className="bg-third text-white border-third text-xs"
                onClick={handleMainWeb}
              >
                Үндсэн сайт руу орох
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        closable
        destroyOnClose
        title={<p>Захиалгын түүх</p>}
        placement="right"
        open={open}
        loading={props?.isorderlist === true ? true : false}
        onClose={() => setOpen(false)}
      >
        <div className="flex flex-col gap-3 full">
          {props?.resorderlist?.length ? (
            renderData()
          ) : (
            <Empty imageStyle={{ height: 60 }} />
          )}
        </div>
      </Drawer>
    </div>
  );
};

export default Index;
